import api from '@/api';
import Context from '@/models/Context';
import Group from '@/models/core/Group';
import Membership from '@/models/core/Membership';
import Topic from '@/models/strategy/Topic';
import slugify from '@/utils/Slugify';

const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isFetched: false
};

// getters
const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  isUpdating(state) {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  },

  setFetched(state, value) {
    state.isFetched = value;
  }
};

// actions
const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
    commit('setFetched', false);
  },

  findForTeam({ commit, state, dispatch }) {
    if (!state.isFetched) {
      const domain = Context.query().first().domain;
      commit('setLoading', true);
      api.get(`/${domain}/groups`).then(response => {
        dispatch(
          'normalize',
          {
            model: Group,
            data: response.data.data
          },
          { root: true }
        ).then(() => {
          commit('setLoading', false);
          commit('setFetched', true);
        });
      });
    }
  },

  create({ commit, dispatch }, newObject) {
    const domain = Context.query().first().domain;

    return new Promise(resolve => {
      commit('setUpdating', true);
      const group = new Group();
      group.name = newObject.name;
      group.slug = slugify(newObject.name);

      api.create(`/${domain}/groups`, Group, group).then(response => {
        dispatch(
          'normalize',
          {
            model: Group,
            data: response.data.data
          },
          { root: true }
        );
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  remove({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(group => {
        commit('setDeleting', true);
        api.remove(Group, group).then(() => {
          Group.delete(group.id);
          commit('setDeleting', false);
          resolve();
        });
      });
    });
  },

  update({ commit }, data) {
    return new Promise(resolve => {
      commit('setUpdating', true);
      api.update(Group, data.group).then(() => {
        Group.insertOrUpdate({ data: data.group });
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  // update({ commit }, data) {
  //   return new Promise(resolve => {
  //     commit('setUpdating', true);

  //     data.values.removed.forEach(topicId => {
  //       const topic = Topic.query()
  //         .where(topic => {
  //           return topic.id === topicId;
  //         })
  //         .first();

  //       topic.groups_collection.splice(
  //         topic.groups_collection.indexOf(data.group.id),
  //         1
  //       );

  //       api.update(Topic, topic);
  //     });

  //     data.values.added.forEach(topicId => {
  //       const topic = Topic.query()
  //         .where(topic => {
  //           return topic.id === topicId;
  //         })
  //         .first();

  //       topic.groups_collection.push(data.group.id);

  //       api.update(Topic, topic);
  //     });

  //     api.update(Group, data.group).then(() => {
  //       commit('setUpdating', false);
  //       resolve();
  //     });
  //   });
  // },

  members({ commit }, data) {
    commit('setUpdating', true);
    const promises = [];

    data.values.removed.forEach(memberId => {
      const member = Membership.query()
        .where(membership => {
          return membership.id === memberId;
        })
        .first();

      member.groups_collection.splice(
        member.groups_collection.indexOf(data.group),
        1
      );

      promises.push(api.update(Membership, member));
    });

    data.values.added.forEach(memberId => {
      const member = Membership.query()
        .where(membership => {
          return membership.id === memberId;
        })
        .first();

      member.groups_collection.push(data.group);

      promises.push(api.update(Membership, member));
    });

    return Promise.all(promises).then(() => {
      commit('setUpdating', false);
      return;
    });

    //return new Promise.all();

    // return new Promise(resolve => {
    //   commit('setUpdating', true);

    //   data.values.removed.forEach(memberId => {
    //     const member = Membership.query()
    //       .where(membership => {
    //         return membership.id === memberId;
    //       })
    //       .first();

    //     member.groups_collection.splice(
    //       member.groups_collection.indexOf(data.group),
    //       1
    //     );

    //     api.update(Membership, member);
    //   });

    //   data.values.added.forEach(memberId => {
    //     const member = Membership.query()
    //       .where(membership => {
    //         return membership.id === memberId;
    //       })
    //       .first();

    //     member.groups_collection.push(data.group);

    //     api.update(Membership, member);
    //   });

    //   commit('setUpdating', false);
    //   resolve();
    // });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
